import { idbDelete, idbGet, idbPut } from "../../../shared/lib/posIdb";

const STORE = "catalog";

/**
 * Persist a catalog snapshot for offline POS selling.
 * @param {string} key e.g. "products" | "customers" | "vendors" | "my-products"
 * @param {unknown} data
 */
export async function saveCatalogCache(key, data) {
  if (!key) return;
  try {
    await idbPut(STORE, {
      key,
      data,
      savedAt: Date.now(),
    });
  } catch {
    // IndexedDB may be blocked (private mode) — fail silently
  }
}

/**
 * @param {string} key
 * @returns {Promise<{ data: unknown, savedAt: number }|null>}
 */
export async function loadCatalogCache(key) {
  if (!key) return null;
  try {
    const row = await idbGet(STORE, key);
    if (!row || row.data == null) return null;
    return { data: row.data, savedAt: row.savedAt || 0 };
  } catch {
    return null;
  }
}

export async function clearCatalogCache(key) {
  try {
    if (key) {
      await idbDelete(STORE, key);
      return;
    }
  } catch {
    /* ignore */
  }
}
